<template>
  <div>
    <b-form-group :label="label"
                  label-cols="3"
                  class="flat form-group--small">
      <multiselect v-model="operator"
                   class="multiselect--small"
                   label="text"
                   track-by="value"
                   :placeholder="operatorPlaceholder ? operatorPlaceholder : $t('options.select_option')"
                   :options="operatorOptions"
                   :multiple="operatorMultiple"
                   @input="toggleDoubleInput($event,'filter-difficulty')">
      </multiselect>
    </b-form-group>
    <b-form-group class="double-input" v-if="showDouble">
      <b-form-input class="col-6 float-left"
                    v-model="lowerValue"
                    :placeholder="lowerValuePlaceholder"
                    @input="applyFilter"
                    @keypress="restrictInput ? isRestricted($event) : null"
                    trim>
      </b-form-input>
      <b-form-input class="col-6 float-right"
                    v-model="higherValue"
                    :placeholder="higherValuePlaceholder"
                    @input="applyFilter"
                    @keypress="restrictInput ? isRestricted($event) : null"
                    trim>
      </b-form-input>
    </b-form-group>
    <b-form-group v-else>
      <b-form-input v-model="singleValue"
                    :placeholder="singleValuePlaceholder"
                    @input="applyFilter"
                    @keypress="restrictInput ? isRestricted($event) : null"
                    trim>
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "InputWithOperator",
  props: [
    'filterName', 'filterQuery', 'label', 'restrictInput', 'restrictionType',
    'operatorMultiple', 'operatorOptions', 'operatorPlaceholder', 'defaultOperator',
    'singleValuePlaceholder', 'lowerValuePlaceholder', 'higherValuePlaceholder',
    'storeData'
  ],
  components: {Multiselect},
  data() {
    return {
      showDouble: false,
      operator: this.defaultOperator,
      singleValue: null,
      lowerValue: null,
      higherValue: null,
    };
  },
  mounted() {
    this.$root.$on('resetFilters', () => {
      this.showDouble = false;
      this.operator = this.defaultOperator;
      this.singleValue = null;
      this.lowerValue = null;
      this.higherValue = null;
    })

    this.checkStoreData();
  },
  methods: {
    checkStoreData() {
      // eslint-disable-next-line no-prototype-builtins
      if (this.storeData && this.storeData.hasOwnProperty(this.filterName)) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.storeData[this.filterName] && this.storeData[this.filterName].value.hasOwnProperty('lowerValue')) {
          this.operator.value = 'btw';
          this.showDouble = true;
          this.lowerValue = this.storeData[this.filterName].value.lowerValue;
          this.higherValue = this.storeData[this.filterName].value.higherValue;
          this.operator = this.storeData[this.filterName].operator;
          this.applyFilter();
        } else if (this.storeData[this.filterName] ) {
          this.singleValue = this.storeData[this.filterName].value;
          this.operator = this.storeData[this.filterName].operator;
          this.applyFilter();
        }
      }
    },
    toggleDoubleInput(operator) {
      this.showDouble = operator && operator.value === 'btw';
      this.applyFilter();
    },
    applyFilter() {
      if(!this.operator) {
        this.operator = this.defaultOperator;
      }

      if (this.operator.value === 'btw' && this.lowerValue !== '' && this.higherValue !== '') {
        this.filterQuery[this.filterName] = '&filters[' + this.filterName + '][0][operator]=gte';
        this.filterQuery[this.filterName] += '&filters[' + this.filterName + '][0][value]=' + this.format(this.lowerValue);
        this.filterQuery[this.filterName] += '&filters[' + this.filterName + '][1][operator]=lte';
        this.filterQuery[this.filterName] += '&filters[' + this.filterName + '][1][value]=' + this.format(this.higherValue);
        this.$emit('store', {
          filterName: this.filterName,
          operator: this.operator,
          value: {lowerValue: this.lowerValue, higherValue: this.higherValue}
        });
      } else if (this.operator.value !== 'btw' && this.singleValue !== '') {
        this.filterQuery[this.filterName] = '&filters[' + this.filterName + '][0][operator]=' + this.operator.value;
        this.filterQuery[this.filterName] += '&filters[' + this.filterName + '][0][value]=' + this.format(this.singleValue);
        this.$emit('store', {
          filterName: this.filterName,
          operator: this.operator,
          value: this.singleValue
        });
      } else {
        this.$emit('store', {
          filterName: this.filterName,
          operator: this.operator,
          value: null
        });
        delete this.filterQuery[this.filterName];
      }
    },
    format(data) {
      if (this.restrictInput && this.restrictionType === 'decimals') {
        return data.toString().replace(',', '.');
      }
      return data;
    },
    isRestricted: function (e) {
      e = (e) ? e : window.event;
      let charCode = (e.which) ? e.which : e.keyCode;
      switch (this.restrictionType) {
        case 'numbers':
          // only 0-9 are allowed
          if (charCode < 48 || charCode > 57) {
            e.preventDefault();
          } else {
            return true;
          }
          break;
        case 'decimals':
          // 0-9 and . are allowed
          if (charCode !== 44 && charCode !== 46 && (charCode < 48 || charCode > 57)) {
            e.preventDefault();
          } else {
            return true;
          }
          break;
        case 'letters':
          // a-z and A-Z are allowed
          if (charCode < 65 || (charCode > 90 && charCode < 97) || charCode > 122) {
            e.preventDefault();
          } else {
            return true;
          }
          break;
        default:
          return true; // no restriction after all
      }
    }
  }
}
</script>
